import {CONFIGURATION_SEQUENCE} from '@constants/resources';
import { BASE_FORM_MESSAGES } from '@constants/messages';
import Form from '@appComponents/ReduxFormControls';
import {CreateSequence, UpdateSequence, DeleteSequence} from '@graphql/sequence/mutation';
import {GetOptions, GetSequence} from '@graphql/sequence/query';
import validators from '@utils/validators';

export const SequenceConfigModel = () => {
    return {
        entityDataMapKey: 'sequence',
        entityLabel: 'sequence config',
        formName: 'sequence',
        resources: CONFIGURATION_SEQUENCE,
        showChangelog: true,
        validate: (values) => {
            const errors = {};

            Object.assign(errors, validators.required(values.name, 'name'));
            Object.assign(errors, validators.maxLength({value: values.name, maxLength: 100}, 'name'));
            Object.assign(errors, validators.required(values.data_source, 'data_source'));

            return errors;
        },
        title: null,
        dataMap: {
            sequence: {
                id: null,
                name: '',
                data_source: null,
                start_delay: null,
                stop_delay: null,
                cutoff: null,
            },
        },
        messages: {
            boxName: {
                success: 'sequenceMessage',
                error: 'sequenceMessageError',
                delete: 'sequenceMessage',
            },
            text: { ...BASE_FORM_MESSAGES },
        },
        fields: {
            id: {
                dataMapKey: 'sequence.id',
                props: {
                    component: Form.IdField,
                    label: '',
                    name: 'id',
                    hidden: true,
                },
            },
            name: {
                dataMapKey: 'sequence.name',
                props: {
                    component: Form.SemanticInput,
                    label: 'Name',
                    name: 'name',
                    required: true,
                },
            },
            data_source: {
                optionsKey: 'sequenceDataSources',
                dataMapKey: 'sequence.sequence_data_source.id',
                props: {
                    component: Form.SemanticSelect,
                    className: '--small-width',
                    label: 'Data source',
                    name: 'data_source',
                    required: true,
                },
            },
            start_delay: {
                dataMapKey: 'sequence.start_delay',
                props: {
                    component: Form.SemanticInput,
                    className: '--small-width',
                    label: 'Start delay',
                    name: 'start_delay',
                    type: 'number',
                    onlyDigitsAllowed: true,
                    labelDescription: {content: 'seconds'},
                    min: 0,
                },
            },
            stop_delay: {
                dataMapKey: 'sequence.stop_delay',
                props: {
                    component: Form.SemanticInput,
                    className: '--small-width',
                    label: 'Stop delay',
                    name: 'stop_delay',
                    type: 'number',
                    onlyDigitsAllowed: true,
                    labelDescription: {content: 'seconds'},
                    min: 0,
                },
            },
            cutoff: {
                dataMapKey: 'sequence.cutoff',
                props: {
                    component: Form.SemanticInput,
                    className: '--small-width',
                    label: 'Cutoff',
                    name: 'cutoff',
                    type: 'number',
                    onlyDigitsAllowed: true,
                    labelDescription: {content: 'minutes'},
                    min: 0,
                },
            },
        },
        mutation: {
            createEntity: CreateSequence,
            updateEntity: UpdateSequence,
            deleteEntity: DeleteSequence,
        },
        query: {
            getEntity: GetSequence,
            getOptions: GetOptions,
        },
    };
};
